<template>
  <div id="data-vis-content">
    <transition-expand>
      <div id="heading" v-if="expandEnabled">
        <div class="container clearfix d-flex align-items-center">
          <div class="d-flex align-items-center float-left">
            <div class="circle-item transition scale-effect">
              <img class="icon" :src="data[getType].Icon" />
            </div>
          </div>
          <div class="description float-left">
            <span>{{ data[getType].Name.toUpperCase() }}</span>
            <p>
              {{ data[getType].Description }}
            </p>
            <p v-if="rcoData">
              {{ rcoData.Footnote }}
            </p>
          </div>
        </div>
      </div>
    </transition-expand>
    <div id="wrapper">
      <div class="row text-center">
        <template v-for="(dataValue, index) in data[getType].Data">
          <div
            class="col mt-2 mb-3"
            :class="{ fadeInDown: $store.state.animations.fadeInDown }"
            :key="index"
            :style="{ 'animation-delay': 1.5 + index / 10 + 's' }"
          >
            <span class="line"></span>
          </div>
        </template>
      </div>
      <div class="circle-tabs row mb-5">
        <template v-for="(dataValue, index) in data[getType].Data">
          <div
            class="col"
            :class="{ fadeInDown: $store.state.animations.fadeInDown }"
            :key="index"
            :style="{ 'animation-delay': 1.5 + index / 10 + 's' }"
          >
            <div
              class="circle-tab"
              :style="{ height: getHeight }"
              :class="{ active: getSelectedRCO === dataValue.Number }"
              v-on:click="setRCO(dataValue.Number)"
            >
              {{ dataValue.Short.toUpperCase() }}
            </div>
          </div>
        </template>
      </div>
      <transition name="fade-custom">
        <InfoChart v-if="getSelectedRCO !== 0"></InfoChart>
      </transition>
    </div>
  </div>
</template>

<script>
import InfoChart from "./InfoChart";
import emsaJson from "../../data.json";
import TransitionExpand from "./TransitionExpand";

export default {
  name: "DataVisContent",
  components: {
    TransitionExpand,
    InfoChart
  },
  data: function() {
    return {
      data: emsaJson,
      circleHeight: 0,
      fadeInDown: true
    };
  },
  computed: {
    getSelectedRCO() {
      return this.$store.getters.getSelectedRCO;
    },
    rcoData() {
      let selectedRCOData = this.data[this.getType].Data;
      let selectedRCO = this.$store.state.firesafe.selectedRCO;
      let result = this.filterByValue(selectedRCOData, selectedRCO);
      return result[0];
    },
    getType() {
      return this.$route.params.type.toUpperCase();
    },
    getHeight() {
      return this.circleHeight + "px";
    },
    expandEnabled() {
      return this.$store.state.animations.expandAnim;
    }
  },
  mounted: function() {
    this.$store.commit("toggleExpand", true);
    this.$store.commit("setSelectedRCO", 0);
    this.circleHeight = document.querySelector(".circle-tab").offsetWidth;
  },
  updated: function() {
    this.circleHeight = document.querySelector(".circle-tab").offsetWidth;
  },
  methods: {
    setRCO(rco) {
      this.$store.commit("setSelectedRCO", rco);
    },
    filterByValue(array, number) {
      return array.filter(function(rco) {
        return rco.Number === number;
      });
    }
  }
};
</script>

<style scoped>
.fade-custom-enter-active {
  transition: all 0.8s ease;
}
.fade-custom-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-custom-enter,
.fade-custom-leave-to {
  opacity: 0;
}
</style>
